import { observable, action, computed, override, makeObservable } from 'mobx';
import {QAAnswer} from 'main/stores/questions';
import AttachedDocument from 'shared/stores/documents/AttachedDocument';
import Question from 'main/stores/recruiting/Question';
import _ from 'lodash';

class Answer extends QAAnswer {
  id;
  content;
  attachment;
  _relations = {
    attachment: AttachedDocument,
    question: Question
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      content: observable,
      attachment: observable,
      removeFile: action,
      mergeFile: action,
      updateFile: action,
      updateValue: override,
      value: computed
    });

    this.merge(other);
  }

  removeFile() {
    this.attachment = null;
  }

  mergeFile(file) {
    this.merge({attachment: file});
  }

  updateFile(files) {
    const file = _.head(files);
    file ? this.mergeFile(file) : this.removeFile();
  }

  updateValue(value) {
    this.content = value;
  }

  get value() {
    return this.content;
  }

  asArray() {
    return this.content || [];
  }
}

export default Answer;
